import React from 'react'
// eslint-disable-next-line
  String.prototype.trunc =
    String.prototype.trunc ||
      function(n) {
        return this.length > n ? this.substr(0, n - 1) + '...' : this
      }
const KendoTextCellRender = props => {
  const { field, dataItem, rowType } = props
  if (rowType === 'groupFooter') {
    return <td></td>
  } else if (rowType === 'groupHeader') {
    return null
  } else {
    return (
      <td style={{ textAlign: 'center' }}>
        <label>{dataItem[field] && dataItem[field].trunc(50)}</label>
      </td>
    )
  }
}

export default KendoTextCellRender
